import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled.div`
  padding-bottom: 15px;
`;

export const Item = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

export const Name = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;
